import { Directive } from '@angular/core';

import { CONTACT_US_TABS, ContactTabType } from '../../../config/header-config.const';

@Directive()
export class ContactComponentAbstract {
  readonly contactTabType = ContactTabType;
  readonly tabContentIdPrefix = 'tab-contact-content-id-';
  tabs = CONTACT_US_TABS;
}
